import type { FlowTraceSessionSummary } from "../../packages/contracts/src/index";

export const resolveBrowserTimeZone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export const sessionDateKey = (
  startedAt: string,
  timeZone: string,
): string => {
  const parts = new Intl.DateTimeFormat("en-US", {
    calendar: "iso8601",
    day: "2-digit",
    month: "2-digit",
    numberingSystem: "latn",
    timeZone,
    year: "numeric",
  }).formatToParts(new Date(startedAt));
  const values = new Map(parts.map(({ type, value }) => [type, value]));

  return `${values.get("year")}-${values.get("month")}-${values.get("day")}`;
};

export const groupSessionsByDate = (
  sessions: FlowTraceSessionSummary[],
  timeZone: string,
): Array<[string, FlowTraceSessionSummary[]]> => {
  const grouped = new Map<string, FlowTraceSessionSummary[]>();
  sessions.forEach((session) => {
    const key = sessionDateKey(session.startedAt, timeZone);
    grouped.set(key, [...(grouped.get(key) ?? []), session]);
  });
  return [...grouped.entries()];
};
